import request from '@/utils/request'

const url = '/home/backupoutbound/'
const api = {
  getBackupoutboundList (data) {
    return request({
      url: url + 'getBackupoutboundList',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  saveBackupoutbound (data) {
    return request({
      url: url + 'saveBackupoutbound',
      method: 'post',
      data
    })
  },
  searchGoods (data) {
    return request({
      url: url + 'searchGoods',
      method: 'post',
      data
    })
  },
  export (data) {
    return request({
      url: url + 'export',
      method: 'post',
      data
    })
  },
  changeOutbound_type (data) {
    return request({
      url: url + 'changeOutbound_type',
      method: 'post',
      data
    })
  },
  getDetail (data) {
    return request({
      url: url + 'getDetail',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/backupOutbound.js